<template>
  <span class="app-badge"
        :class="{
             'app-badge--small': size === 'small',
             'app-badge--medium': size === 'medium',
             'app-badge--neutral': variant === 'neutral',
             'app-badge--danger': variant === 'danger',
             'app-badge--info': variant === 'info',
          }"
        v-bind="$attrs"
  >
    <slot></slot>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export type AppBadgeSize = 'small' | 'medium'
export type AppBadgeVariant = 'danger' | 'info' | 'neutral'

/**
 * @displayName Principal Button
 */
export default defineComponent({
  name: 'AppBadge',
  inheritAttrs: false,
  props: {
    /**
     * Size of the badge
     * Possible values are : small, medium
     */
    size: {
      type: String as PropType<AppBadgeSize>,
      default: 'medium',
    },
    /**
     * Color variant
     * Possible values are : danger, info, neutral
     */
    variant: {
      type: String as PropType<AppBadgeVariant>,
      default: 'neutral',
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/typography-tokens";

.app-badge {
  align-items: center;
  @include border-radius('border-radius-2');
  padding: 0 4px;
  text-transform: uppercase;
  user-select: none;
  @include text ('detail-md-bold');

  &.app-badge--small {
    height: 16px;
    min-width: 15px;
    display: inline-flex;
    justify-content: start;
    align-items: center;
  }

  &.app-badge--medium {
    height: 20px;
  }

  &.app-badge--neutral {
    background-color: rgb(var(--v-theme-surface-grey-subtle));
    color: rgb(var(--v-theme-text-grey));
  }

  &.app-badge--danger {
    background-color: rgb(var(--v-theme-error));
    color: rgb(var(--v-theme-white));
  }

  &.app-badge--info {
    background-color: rgb(var(--v-theme-surface-info-bold));
    color: rgb(var(--v-theme-text-inverted));
  }
}
</style>
